import { render, staticRenderFns } from "./LectureForm.vue?vue&type=template&id=90de245c&"
import script from "./LectureForm.vue?vue&type=script&lang=ts&"
export * from "./LectureForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports